export const ANNUAL_POSSIBLE_GROWTH = 0.05;
